<template>
  <form class="clearfix ">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.push')"></general-top-bar> -->
    <!--End General Top Bar -->
    <template v-for="(notif, keyNotif) in model">
      <div class="card card-inline100">
        
        <div class="form-group card col-md-12" style="background-color: #fff;">
            <div class="card__title">
              <h6>{{$t('deliveryTypes.' + notif.delivery_type)}}</h6>
            </div>
            <hr class="sm"/>
            <template v-for="(message, keyMessage) in notif.messages">
              <div class="form-group">
                <label class="">{{changeDeliveryStatusOnEatLocation( notif.delivery_type, message.status)}}</label>
                <div v-if="message.status === 'PROCESSING' || (message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION')">
                <template v-if="notif.delivery_type === 'EAT_LOCATION'">
                  <input type="text" 
                        class="form-control auto-width" 
                        v-model="notifBits[notif.delivery_type][message.status][0]" 
                        v-validate="modelValidations.text"
                        name="validateDefault"
                        :style="'width: ' + ((notifBits[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'"
                        />
                  <span> {{$t('settingsPushNotif.persons')}} </span>
                  <input type="text" 
                        class="form-control auto-width" 
                        v-model="notifBits[notif.delivery_type][message.status][1]" 
                        v-validate="modelValidations.text"
                        name="validateDefault"
                        :style="'width: ' + ((notifBits[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'"
                        />
                  <span> {{$t('settingsPushNotif.dateTime')}} </span>
                  <input type="text" 
                        class="form-control auto-width" 
                        v-model="notifBits[notif.delivery_type][message.status][2]"
                        :style="'width: ' + ((notifBits[notif.delivery_type][message.status][2].length + 1)*8 + 20) + 'px'"
                        />
                  <div class="pad-to-5">
                    {{$t('settingsPushNotif.preview')}}: 
                    <span class="text-italic">
                    {{ notifBits[notif.delivery_type][message.status][0] }} 
                    {{$t('settingsPushNotif.personsPrev')}} 
                    {{notifBits[notif.delivery_type][message.status][1]}}
                    <template v-if="notifBits[notif.delivery_type][message.status][2] !== ''">
                      <template v-if="notifBits[notif.delivery_type][message.status][2] !== ' '">
                        {{$t('settingsPushNotif.dateTimePrev')}} 
                        {{notifBits[notif.delivery_type][message.status][2]}}
                      </template>
                    </template>
                  </span>
                    </div> 
                    <div class="pad-to-5">
                    <span style="font-size: 0.7em">{{$t('settingsPushNotif.info')}}</span>
                  </div>
                </template>
                <template v-else>
                  <input type="text" 
                        class="form-control auto-width" 
                        v-model="notifBits[notif.delivery_type][message.status][0]" 
                        v-validate="modelValidations.text"
                        name="validateDefault"
                        :style="'width: ' + ((notifBits[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'" 
                        />
                  <span> {{$t('settingsPushNotif.time')}} </span>
                  <input type="text" 
                        class="form-control auto-width" 
                        v-model="notifBits[notif.delivery_type][message.status][1]" 
                        :style="'width: ' + ((notifBits[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'" 
                        />
                  <div class="pad-to-5">
                    {{$t('settingsPushNotif.preview')}}: 
                    <span class="text-italic">{{ notifBits[notif.delivery_type][message.status][0] }}
                      <template v-if="notifBits[notif.delivery_type][message.status][1] !== ''">
                        <template v-if="notifBits[notif.delivery_type][message.status][1] !== ' '">
                          {{$t('settingsPushNotif.timePrev')}} {{notifBits[notif.delivery_type][message.status][1]}}
                        </template>
                      </template>
                    </span>
                    </div> 
                    <div class="pad-to-5">
                    <span style="font-size: 0.7em">{{$t('settingsPushNotif.info')}}</span>
                  </div>
                </template>    
                </div>
                <div v-else>
                  <input type="text" class="form-control" v-model="message.message" v-validate="modelValidations.text"/>
                </div>
              </div>
            </template>
              <button 
                @click.prevent="validate" 
                :title="$t('general.update')"
                class="btn btn-success btn-icon save mar-bt-15"
              >
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
              </button>
            </div>
        </div>

        <template v-for="(message, keyMessage) in customNotifications">
          <template v-if="message.delivery_type.toLowerCase() === notif.delivery_type.toLowerCase()">
            <div class="form-group card col-md-12" style="background-color: #fff;">
              <div class="form-group">
                <br>
                <template v-if='message.id'>
                  {{$t('settingsPushNotif.selectedLocations')}}
                  <template v-for="(loc, keyloc) in message.location_ids">
                    <b style="margin-right: 10px">{{getLocationById(loc)}}</b>
                  </template>
                  <br>
                </template>
                <template v-else>
                  <label for="">
                    {{$t('dashboard.selectLocation')}}
                  <el-select
                    v-if="savedLocations.length"
                    :key="'select' + message.id"
                    :name="'section_' + message.id + '_'+message.delivery_type"
                    :multiple-limit = '(locationsAvailable2(message).length - 1)'
                    v-model="message.location_ids"
                    v-validate="customModelValidations.select"
                    multiple
                    filterable
                    default-first-option
                    :placeholder="$t('general.add')">
                    <template v-for="item in locationsAvailable(message)">
                      <template v-for="or in item.ordering_management">
                        <template v-if="message.delivery_type.toLowerCase() === or.type">
                          <el-option
                            :disabled="or.notifSelected"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </template>
                      </template>
                    </template>
                  </el-select>
                  </label>
                </template>

                <br>
                <template v-for="msg in message.message">
                    <label class="">{{changeDeliveryStatusOnEatLocation( message.delivery_type.toUpperCase(), msg.status)}}</label>
                    <div v-if="msg.status === 'PROCESSING' || (msg.status === 'DELIVERED' && message.delivery_type.toUpperCase() === 'EAT_LOCATION')">
                      <template v-if="message.bits">
                      <template v-if="message.delivery_type.toLowerCase() === 'eat_location'">
                        <input type="text" 
                              class="form-control auto-width" 
                              v-model="message.bits[0]" 
                              v-validate="customModelValidations.text"
                              :name="'section_' + message.id + '_'+message.delivery_type"
                              :style="'width: ' + ((message.bits[0].length + 1)*8 + 20) + 'px'" 
                              />
                        <span> {{$t('settingsPushNotif.persons')}} </span>
                        <input type="text" 
                              class="form-control auto-width" 
                              v-model="message.bits[1]" 
                              v-validate="customModelValidations.text"
                              :name="'section_' + message.id + '_'+message.delivery_type"
                              :style="'width: ' + ((message.bits[1].length + 1)*8 + 20) + 'px'" 
                              />
                        <span> {{$t('settingsPushNotif.dateTime')}} </span>
                        <input type="text" 
                              class="form-control auto-width" 
                              v-model="message.bits[2]"
                              :name="'section_' + message.id + '_'+message.delivery_type"
                              :style="'width: ' + ((message.bits[2].length + 1)*8 + 20) + 'px'" 
                              />
                        <div class="pad-to-5">
                          {{$t('settingsPushNotif.preview')}}: 
                          <span class="text-italic">
                          {{ message.bits[0] }} 
                          {{$t('settingsPushNotif.personsPrev')}} 
                          {{message.bits[1]}}
                          <template v-if="message.bits[2] !== ''">
                            <template v-if="message.bits[2] !== ' '">
                              {{$t('settingsPushNotif.dateTimePrev')}} 
                              {{message.bits[2]}}
                            </template>
                          </template>
                        </span>
                          </div> 
                          <div class="pad-to-5">
                          <span style="font-size: 0.7em">{{$t('settingsPushNotif.info')}}</span>
                        </div>
                        <br>
                      </template>
                      <template v-else>
                        <input type="text" 
                              class="form-control auto-width" 
                              v-model="message.bits[0]" 
                              v-validate="customModelValidations.text"
                              :name="'section_' + message.id + '_'+message.delivery_type"
                              :style="'width: ' + ((message.bits[0].length + 1)*8 + 20) + 'px'" 
                              />
                        <span> {{$t('settingsPushNotif.time')}} </span>
                        <input type="text" 
                              class="form-control auto-width" 
                              v-model="message.bits[1]" 
                              :style="'width: ' + ((message.bits[1].length + 1)*8 + 20) + 'px'" 
                              />
                        <div class="pad-to-5">
                          {{$t('settingsPushNotif.preview')}}: 
                          <span class="text-italic">{{ message.bits[0] }} 
                            <template v-if="message.bits[1] !== ''">
                              <template v-if="message.bits[1] !== ' '">
                                {{$t('settingsPushNotif.timePrev')}} {{message.bits[1]}}
                              </template>
                            </template>
                          </span>
                          </div> 
                          <div class="pad-to-5">
                          <span style="font-size: 0.7em">{{$t('settingsPushNotif.info')}}</span>
                        </div>
                      </template>    
                      </template>
                    </div>
                    <div v-else>
                      <input type="text" class="form-control" v-model="msg.message" v-validate="customModelValidations.text"/>
                    </div>
                </template>

                <div style="margin-top: 10px">
                  <button 
                    @click.prevent="validateSingleSection('section_' + message.id + '_'+message.delivery_type, message.id, message.delivery_type)" 
                    :title="$t('general.update')"
                    class="btn btn-success btn-icon save"
                  >
                    <img src="/static/img/icons/save.png">
                    {{$t('general.save')}}
                  </button>
                  <template v-if='message.id'>
                    <button 
                      @click.prevent="deleteBox(message.id, message.delivery_type)"
                      class="btn btn-danger btn-icon"
                    >
                      <i class="ti-close"></i>
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </template>
        <div class="col-md-12" >
          <button
            v-show="showIfHasMultipleLocation[notif.delivery_type]"
            @click.prevent="addBoxForLocation(notif.delivery_type)"
            class="btn add mar-bt-15"
          >
            <img src="/static/img/icons/add.png">
            {{$t('general.add')}}
          </button>
        </div>
      </div>
    </template>
    <!-- ////////////////////// Notificari Puncte de Loialitate -->
    <template v-for="(notif, keyNotif) in defaults">
      <div class="card card-inline100">
        
        <div class="form-group card col-md-12" style="background-color: #fff;">
            <div class="card__title">
              <h6>{{ $t('marketingFidelities.loyalityPoint') }}</h6>
            </div>
            <hr class="sm"/>
            <template v-for="(message, keyMessage) in notif.messages">
              <div class="form-group">
                <label class="">{{$t('ordersStatus.DELIVERED')}}</label>
                <div>
                  <template v-if="customLoyaltyPointsNotifications[0] && customLoyaltyPointsNotifications[0]['bits']">
                    <input type="text" 
                          class="form-control auto-width" 
                          v-validate="modelValidations.text"
                          v-model="customLoyaltyPointsNotifications[0]['bits'][0]" 
                          name="validateDefault"
                          :style="'width: ' + ((customLoyaltyPointsNotifications[0]['bits'][0].length + 1)*8 + 20) + 'px'"
                          />
                    <span> {{ $t('settingsPushNotif.pointsPrev') }} </span>
                    <input type="text" 
                          class="form-control auto-width"
                          v-validate="modelValidations.text"
                          v-model="customLoyaltyPointsNotifications[0]['bits'][1]" 
                          name="validateDefault"
                          :style="'width: ' + ((customLoyaltyPointsNotifications[0]['bits'][1].length + 1)*8 + 20) + 'px'"
                          />
                    <span> {{ $t('settingsPushNotif.worthPrev') }} </span>
                    <input type="text" 
                          class="form-control auto-width"
                          v-model="customLoyaltyPointsNotifications[0]['bits'][2]"
                          :style="'width: ' + ((customLoyaltyPointsNotifications[0]['bits'][2].length + 1)*8 + 20) + 'px'"
                          />
                    <div class="pad-to-5">
                      {{ $t('settingsPushNotif.preview') }}:
                      <span class="text-italic">
                        {{ customLoyaltyPointsNotifications[0]['bits'][0] }}
                        {{ loyalty_value_one_point_amount ? loyalty_value_one_point_amount : 'X' }}
                        {{ customLoyaltyPointsNotifications[0]['bits'][1] }}
                        <template v-if="customLoyaltyPointsNotifications[0]['bits'][2].trim().length > 0">
                          {{ loyalty_value_one_point ? loyalty_value_one_point : 'Y' }}
                          {{ currency }}
                        </template>
                        <template v-if="customLoyaltyPointsNotifications[0]['bits'][2].trim().length > 0">
                          {{customLoyaltyPointsNotifications[0]['bits'][2]}}
                        </template>
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <input type="text" 
                          class="form-control auto-width" 
                          v-model="notifLoyaltyPoints[notif.delivery_type][message.status][0]" 
                          name="validateDefault"
                          :style="'width: ' + ((notifLoyaltyPoints[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'"
                          />
                    <span> {{ $t('settingsPushNotif.pointsPrev') }} </span>
                    <input type="text" 
                          class="form-control auto-width" 
                          v-model="notifLoyaltyPoints[notif.delivery_type][message.status][1]" 
                          name="validateDefault"
                          :style="'width: ' + ((notifLoyaltyPoints[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'"
                          />
                    <span> {{ $t('settingsPushNotif.worthPrev') }} </span>
                    <input type="text" 
                          class="form-control auto-width" 
                          v-model="notifLoyaltyPoints[notif.delivery_type][message.status][2]"
                          :style="'width: ' + ((notifLoyaltyPoints[notif.delivery_type][message.status][2].length + 1)*8 + 20) + 'px'"
                          />
                    <div class="pad-to-5">
                      {{ $t('settingsPushNotif.preview') }}: 
                      <span class="text-italic">
                        {{ notifLoyaltyPoints[notif.delivery_type][message.status][0] }} 
                        {{ loyalty_value_one_point_amount ? loyalty_value_one_point_amount : 'X' }} 
                        {{ notifLoyaltyPoints[notif.delivery_type][message.status][1] }}
                        <template v-if="notifLoyaltyPoints[notif.delivery_type][message.status][2].trim().length > 0">                        
                          {{ loyalty_value_one_point ? loyalty_value_one_point : 'Y' }}
                          {{ currency }}
                        </template>
                        <template v-if="notifLoyaltyPoints[notif.delivery_type][message.status][2].trim().length > 0">
                          {{ notifLoyaltyPoints[notif.delivery_type][message.status][2] }}
                        </template>
                      </span>
                    </div> 
                  </template>
                </div>
              </div>
            </template>
            <div class="pad-bt-10">
              <button 
                @click.prevent="saveLoyaltyPointsNotification()" 
                :title="$t('general.update')"
                class="btn btn-success btn-icon save"
              >
                <img src="/static/img/icons/save.png">
                {{$t('general.save')}}
              </button>
            </div>
        </div>
      </div>
    </template>
  </form> 
</template>

<style scoped lang="scss">
  .card__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 10px;
  }
  .card-inline100 {
    display: inline-block;
    width: 100%;
    padding-bottom: 20px;
    background: #F4F6FF;
    padding: 10px;
  }
</style>

<style lang="scss">
  .card-inline100 {
    span.el-select__tags-text {
      color: #fff !important;
    }
  }
</style>

<script>
  import Vue from 'vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import {Input, Button, Select} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select
      // GeneralTopBar
    },
    props: {
      defaultData: {},
      modeldata: {},
      locations: {}
    },
    watch: {
      modeldata: {
        immediate: true,
        handler (value) {
          if (!value || !value.length) {
            return
          }
          this.model = value
          this.savedLocations = this.copyVar(this.locations)
          this.checkIfHasMutipleLocationAvailable()
          this.setUpBits(value)
          this.setUpCustomBits()
        }
      },
      defaultData: {
        immediate: true,
        handler (value) {
          if (!value || !value.length) {
            return
          }
          this.defaults = value
          this.setUpLoyaltyPointsBits(value)
          this.setUpCustomBits()
        }
      },
      locations: {
        immediate: true,
        handler (value) {
          if (!value) {
            return
          }
          this.savedLocations = this.copyVar(value)
          this.checkIfHasMutipleLocationAvailable()
        }
      }
    },
    data () {
      return {
        savedLocations: [],
        showIfHasMultipleLocation: {
          'DELIVERY': false,
          'PICK_UP': false,
          'MEET_HALF': false,
          'EAT_LOCATION': false,
          'LOYALTY_POINTS': true
        },
        labels: {
          'order_new': this.$t('settingsPushNotif.order_new'),
          'order_completed_pickup': this.$t('settingsPushNotif.order_completed_pickup'),
          'order_completed_meet': this.$t('settingsPushNotif.order_completed_meet'),
          'order_completed_delivery': this.$t('settingsPushNotif.order_completed_delivery'),
          'order_completed_eat': this.$t('settingsPushNotif.order_completed_eat'),
          'order_canceled': this.$t('settingsPushNotif.order_canceled')
        },
        model: this.value || this.modeldata,
        defaults: this.value || this.defaultData, // this.countries
        modelValidations: {
          text: { required: true }
        },
        customModelValidations: {
          text: { required: true },
          select: { required: true }
        },
        parameters: [
          '{time}',
          '{date_time}',
          '{persons_number}'
        ],
        notifBits: {
          'DELIVERY': {
            'PROCESSING': ['', '']
          },
          'PICK_UP': {
            'PROCESSING': ['', '']
          },
          'MEET_HALF': {
            'PROCESSING': ['', '']
          },
          'EAT_LOCATION': {
            'DELIVERED': ['', '', '']
          }
        },
        notifLoyaltyPoints: {
          'LOYALTY_POINTS': {
            'DELIVERED': ['', '', '']
          }
        },
        customNotifications: [],
        customLoyaltyPointsNotifications: [],
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        loyalty_value_one_point: '',
        loyalty_value_one_point_amount: ''
      }
    },
    mounted () {
      this.$nextTick(function () {
        // next tick
      })
    },
    created () {
      this.getAndSaveNotif()
      this.loyalty_value_one_point_amount = Math.round(this.$session.get('selectedCompanyData').loyalty_value_one_point_amount * 10) / 10
      this.loyalty_value_one_point = this.$session.get('selectedCompanyData').loyalty_value_one_point
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        // this.$validator.validateAll().then(isValid => {
        this.$validator.validate('validateDefault').then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      validateSingleSection (sectionName, id, type) {
        // this.$validator.validateAll().then(isValid => {
        this.$validator.validate(sectionName).then(isValid => {
          if (isValid) {
            this.saveBox(id, type)
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop][0])
            // console.warn(this.errors)
          }
        }
      },
      setUpBits (model) {
        for (var idx in model) {
          let notif = model[idx]
          for (var notifIdx in notif.messages) {
            let message = notif.messages[notifIdx]
            if (
              message.status === 'PROCESSING' ||
              (message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION')
            ) {
              let bits = this.getBits(message.message || '', notif.delivery_type)
              if (!this.notifBits[notif.delivery_type]) {
                Vue.set(this.notifBits, notif.delivery_type, {})
              }
              Vue.set(this.notifBits[notif.delivery_type], message.status, bits)
            }
          }
        }
      },
      setUpLoyaltyPointsBits () {
        let bits = this.getLoyaltyPointsBits()
        this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'] = bits
      },
      setUpCustomBits () {
        for (var notif of this.customNotifications) {
          for (var message of notif.message) {
            if (
                message.status.toUpperCase() === 'PROCESSING' ||
                (message.status.toUpperCase() === 'DELIVERED' && notif.delivery_type.toUpperCase() === 'EAT_LOCATION') ||
                (message.status.toUpperCase() === 'DELIVERED' && notif.delivery_type.toUpperCase() === 'LOYALTY_POINTS')
              ) {
              let bits = this.getBits(message.message, notif.delivery_type.toUpperCase())
              Vue.set(notif, 'bits', bits) // for reactivity in depth
              // notif.bits = bits
            }
          }
        }
      },
      setCustomLoyaltyPointsNotifications () {
        if (this.customNotifications) {
          let result = null
          for (let element of this.customNotifications) {
            if (element.delivery_type === 'loyalty_points') {
              result = element
            }
          }
          this.customLoyaltyPointsNotifications[0] = result
        }
      },
      setUpCustomLoyaltyPointsBits () {
        let bits = this.getLoyaltyPointsBits()
        Vue.set(this.customLoyaltyPointsNotifications[0], 'bits', bits) // for reactivity in depth
      },
      getBits (message, type) {
        let bits = ''
        switch (type) {
          case 'LOYALTY_POINTS':
            bits = message.split('{gainedPoints}')
            if (bits.length < 2) {
              bits.push(' ')
              bits.push(' ')
              return bits
            } else {
              let bits2 = bits[1].split('{worth}')
              if (bits2.length < 2) {
                bits2.push(' ')
              }
              bits[1] = bits2[0]
              bits[2] = bits2[1]
            }
            return bits
          case 'EAT_LOCATION':
            bits = message.split('{persons_number}')
            if (bits.length < 2) {
              bits.push(' ')
              bits.push(' ')
              return bits
            } else {
              let bits2 = bits[1].split('{date_time}')
              if (bits2.length < 2) {
                bits2.push(' ')
              }
              bits[1] = bits2[0]
              bits[2] = bits2[1]
            }
            return bits
          default:
            let bitsDef = String(message || '').split('{time}')
            if (bitsDef.length < 2) {
              // Sentinel: message has no {time} placeholder
              bitsDef.push(' ')
            }
            return bitsDef
        }
        // this.parameters
      },
      getLoyaltyPointsBits () {
        if (this.customLoyaltyPointsNotifications && this.customLoyaltyPointsNotifications.bits) {
          return this.customLoyaltyPointsNotifications.bits
        } else {
          let message = this.defaults[0]['messages'][0]['message']
          let bits = ''
          bits = message.split('{gainedPoints}')
          if (bits.length < 2) {
            bits.push(' ')
            bits.push(' ')
            return bits
          } else {
            let bits2 = bits[1].split('{worth}')
            if (bits2.length < 2) {
              bits2.push(' ')
            }
            bits[1] = bits2[0]
            bits[2] = bits2[1]
          }
          return bits
        }
      },
      getMsgFromBits (type, status) {
        var bits = this.notifBits[type][status]
        switch (type) {
          case 'EAT_LOCATION':
            return bits[0] + '{persons_number}' + bits[1] + '{date_time}' + bits[2]
          case 'LOYALTY_POINTS':
            return bits[0] + '{gainedPoints}' + bits[1] + '{worth}' + bits[2]
          default:
            // bits[1] === ' ' means original message had no {time}
            // bits[1] === '' means user cleared trailing text to hide {time}
            if (bits[1] === '' || bits[1] === ' ') {
              return bits[0]
            }
            return bits[0] + '{time}' + bits[1]
        }
      },
      saveBox (id, type) {
        // var companyID = this.$session.get('selectedCompany')
        // get special messages
        let forSave = []
        for (var notiff of this.customNotifications) {
          if (notiff.delivery_type === type && notiff.id === id) {
            forSave.push(notiff)
          }
        }
        for (var notif of forSave) {
          for (var message of notif.message) {
            if (
                message.status.toUpperCase() === 'PROCESSING' ||
                (message.status.toUpperCase() === 'DELIVERED' && notif.delivery_type.toUpperCase() === 'EAT_LOCATION') ||
                notif.delivery_type.toUpperCase() === 'LOYALTY_POINTS'
              ) {
              switch (notif.delivery_type.toUpperCase()) {
                case 'EAT_LOCATION':
                  message.message = notif.bits[0] + '{persons_number}' + notif.bits[1] + '{date_time}' + notif.bits[2]
                  break
                case 'LOYALTY_POINTS':
                  message.message = notif.bits[0] + '{gainedPoints}' + notif.bits[1] + '{worth}' + notif.bits[2]
                  break
                default:
                  if (notif.bits[1] === '' || notif.bits[1] === ' ') {
                    message.message = notif.bits[0]
                  } else {
                    message.message = notif.bits[0] + '{time}' + notif.bits[1]
                  }
                  break
              }
            }
          }
        }
        this.getAndSaveNotif(forSave)
      },
      getAndSaveNotif (saveNotif = []) {
        var data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'push_notifications': JSON.stringify(saveNotif)
        }
        this.apiRequest('/settings/notif', 'POST', data, (response) => {
          if (response.success === true) {
            this.customNotifications = response.data
            for (var not of this.customNotifications) {
              not.location_ids = JSON.parse(not.location_ids)
              not.message = JSON.parse(not.message)
              for (var locid of not.location_ids) {
                for (const loc of this.savedLocations) {
                  if (locid === loc.id) {
                    for (const ord of loc.ordering_management) {
                      if (not.delivery_type === ord.type) {
                        ord.notifSelected = true
                      }
                    }
                  }
                }
              }
            }
            this.setCustomLoyaltyPointsNotifications()
            this.$nextTick(() => {
              this.checkIfHasMutipleLocationAvailable()
              this.setUpCustomBits()
            })
          }
        })
      },
      saveDetails () {
        var companyID = this.$session.get('selectedCompany')

        // get special messages
        for (var idx in this.model) {
          let notif = this.model[idx]
          for (var notifIdx in notif.messages) {
            let message = notif.messages[notifIdx]
            if (
              message.status === 'PROCESSING' ||
              (message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION')
            ) {
              this.model[idx].messages[notifIdx].message = this.getMsgFromBits(notif.delivery_type, message.status)
            }
          }
        }

        var data = {
          'token': this.$session.get('token'),
          'push_notifications': JSON.stringify(this.model)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.errors.clear()
            swal({'text': self.$t('settingsPushNotif.notifUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch({})
          } else {
            swal({'text': self.$t('validationa.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch({})
          }
        })
      },
      setUpMessageLoyaltyPoints () {
        let message = ''
        if (this.customLoyaltyPointsNotifications[0]) {
          message = this.customLoyaltyPointsNotifications[0]['bits'][0] + ' {gainedPoints} ' + this.customLoyaltyPointsNotifications[0]['bits'][1]
          if (this.customLoyaltyPointsNotifications[0]['bits'][2].trim().length > 0) {
            message = message + ' {worth} ' + this.customLoyaltyPointsNotifications[0]['bits'][2]
          }
          return message
        }

        if (this.notifLoyaltyPoints && this.notifLoyaltyPoints['LOYALTY_POINTS'] && this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED']) {
          message = this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'][0] + ' {gainedPoints} ' + this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'][1]
          if (this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'][2].trim().length > 0) {
            message = message + ' {worth} ' + this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'][2]
          }
          return message
        }
      },
      saveLoyaltyPointsNotification () {
        let message = this.setUpMessageLoyaltyPoints()
        let notification = [{
          'company_id': this.$session.get('selectedCompany'),
          'delivery_type': 'loyalty_points',
          'location_ids': [],
          'message': [{
            'status': 'DELIVERED',
            'message': message
          }]
        }]

        var data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'push_notifications': JSON.stringify(notification)
        }

        this.apiRequest('/settings/loyalty-points-notification', 'POST', data, (response) => {
          if (response.success === true) {
            this.customLoyaltyPointsNotifications[0] = response.data
            this.setUpCustomLoyaltyPointsBits()
            swal({'text': this.$t('settingsPushNotif.notifUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch({})
          } else {
            swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
          }
        })
      },
      changeDeliveryStatusOnEatLocation (deliveryType, status) {
        if (deliveryType === 'EAT_LOCATION' && status === 'DELIVERED') {
          status = 'RESERVED'
        }
        return this.$t('ordersStatus.' + status)
      },
      checkIfHasMutipleLocationAvailable () {
        if (!this.model) return
        for (var notif of this.model) {
          let flag = 0
          let type = notif.delivery_type.toLowerCase()
          for (var element of this.savedLocations) {
            for (var element2 of element.ordering_management) {
              if (element2.type.toLowerCase() === type) {
                if (element2.enabled && !element2.notifSelected) {
                  flag++
                  // break
                }
              }
            }
            // if (flag) {
            //   break
            // }
          }
          if (flag === 1) {
            flag = 0
          }
          if (this.customNotifications.length) {
            for (var not of this.customNotifications) {
              if (not.delivery_type.toLowerCase() === type && not.id === 0) {
                flag = 0
              }
            }
          }
          this.showIfHasMultipleLocation[notif.delivery_type] = !!flag
        }
      },
      addBoxForLocation (type) {
        const message = this.model.filter(m => m.delivery_type.toLowerCase() === type.toLowerCase())
        var msg = this.copyVar(message[0].messages)
        this.customNotifications.push({
          'id': 0,
          'delivery_type': type.toLowerCase(),
          'location_ids': [],
          'message': msg
        })
        this.checkIfHasMutipleLocationAvailable()
        this.setUpCustomBits()
      },
      getLocationById (id) {
        for (var element of this.locations) {
          if (element.id === id) {
            return element.name
          }
        }
      },
      deleteBox (id, type) {
        var data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'id': id
        }
        this.apiRequest('/settings/delete-notif', 'POST', data, (response) => {
          if (response.success === true) {
            this.customNotifications = response.data
            for (const not of this.customNotifications) {
              not.location_ids = JSON.parse(not.location_ids)
              not.message = JSON.parse(not.message)
            }
            this.checkIfHasMutipleLocationAvailable()
            this.setUpCustomBits()
            this.showIfHasMultipleLocation[type.toUpperCase()] = true
          }
        })
      },
      locationsAvailable (message) {
        const filteredLocations = []
        for (const item of this.savedLocations) {
          for (const ord of item.ordering_management) {
            if (ord.type === message.delivery_type.toLowerCase() && ord.enabled) {
              if (this.checkInCustomNot(item.id, message.delivery_type.toLowerCase())) {
                ord.notifSelected = false
              } else {
                ord.notifSelected = true
              }
              filteredLocations.push(item)
            }
          }
        }
        return filteredLocations
      },
      locationsAvailable2 (message) {
        const filteredLocations = []
        for (const item of this.savedLocations) {
          for (const ord of item.ordering_management) {
            if (ord.type === message.delivery_type.toLowerCase() && ord.enabled) {
              if (this.checkInCustomNot(item.id, message.delivery_type.toLowerCase())) {
                ord.notifSelected = false
              } else {
                ord.notifSelected = true
              }
              filteredLocations.push(ord)
            }
          }
        }
        return filteredLocations
      },
      checkInCustomNot (id, type) {
        let flag = 0
        for (const notiff of this.customNotifications) {
          if (type === notiff.delivery_type) {
            if (notiff.location_ids.length) {
              for (const loc of notiff.location_ids) {
                if (loc === id) {
                  flag++
                }
              }
            }
          }
        }
        return !flag
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/PushNotifications.vue